<template>
  <v-layout>
    <div class="col">
      <div class="head-page-title">
        <h1 class="main-title">Kaart beëindigen</h1>
      </div>
      <div class="panel">
        <div class="row">
          <div class="small-12 columns">
            <div id="select-cards-text">Kies één of meerdere kaarten die beëindigd dienen te worden.</div>
            <h3 class="main-title">Zoek kaart</h3>
            <terminate-card-filter-form @filter="loadData" @reset-filter="loadData"/>

            <div class="datatable-wrapper">
              <div class="dataTables_wrapper dt-foundation no-footer">
                <table class="datatable datatable-row-click dataTable no-footer" role="grid" style="width: 800px;">
                  <thead>
                    <table-header :order-by="orderBy"
                                  :order-direction="orderDirection"
                                  :columns="headerColumns"
                                  translation-prefix="orderTerminateCard.headerColumns."
                                  @orderingChanged="setOrderingAndLoadData"/>
                  </thead>
                  <tbody>
                    <tr is="order-terminate-card-list-item"
                        v-for="cardSummary in allResults"
                        :card-summary="cardSummary"
                        :key="cardSummary.cardId"
                        :is-card-checked="isCardChecked(cardSummary.cardId)"
                        @rowCheckChange="updateRowCheck"/>
                    <tr v-if="!allResults || allResults.length === 0">
                      <td :colspan="headerColumns.length">Geen resultaten</td>
                    </tr>
                  </tbody>
                </table>
                <div class="bottom">
                  <div class="dataTables_paginate paging_full_numbers">
                    <order-terminate-card-list-paginator :page-size="pageSize" @paginationChanged="loadData"/>
                  </div>
                </div>
                <div class="clear"/>
              </div>
            </div>

            <a v-if="selectedItems.length > 0"
               id="submitCardTermination"
               class="button"
               @click="submitCardTermination">{{ $t('orderTerminateCard.submitCardTermination') }} *</a>
            <div id="submitCardTerminationText">* {{ $t('orderTerminateCard.cardTerminationWarningMessage') }}</div>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import TerminateCardFilterForm from '../components/forms/TerminateCardFilterForm'
import VLayout from '../layouts/Default'
import {buildTableHeaderColumn} from '../types/table-header-column'
import TableHeader from '../components/tableHeader/TableHeader'
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import showAlertErrorHandler from '../mixins/show-alert-error-handler'
import {
  ADD_SELECTED_ITEM,
  DELETE_SELECTED_ITEM,
  SET_ORDER_BY,
  SET_ORDER_DIRECTION,
  SET_PAGE_SIZE,
  SET_SELECTED_ITEMS
} from '../store/modules/order-terminate-card/mutation-types'
import OrderTerminateCardListPaginator from '../components/orderTerminateCard/OrderTerminateCardListPaginator'
import OrderTerminateCardListItem from '../components/orderTerminateCard/OrderTerminateCardListItem'

export default {
  name: 'OrderTerminateCardPage',
  components: {
    OrderTerminateCardListPaginator,
    OrderTerminateCardListItem,
    VLayout,
    TerminateCardFilterForm,
    TableHeader
  },
  mixins: [showAlertErrorHandler],
  data: () => {
    return {
      selectedCardIds: [],
      headerColumns: [
        buildTableHeaderColumn('multiSelect', null, null, false, false),
        buildTableHeaderColumn('engravedId'),
        buildTableHeaderColumn('cardHolderDetails'),
        buildTableHeaderColumn('combinedAscriptions'),
        buildTableHeaderColumn('cardValidUntil')
      ]
    }
  },
  computed: {
    ...mapState('orderTerminateCard', [
      'searchResultItemsForCurrentFilter',
      'selectedItems',
      'pageSize',
      'orderBy',
      'orderDirection',
      'filter'
    ]),
    ...mapGetters('orderTerminateCard', [
      'allResults'
    ])
  },
  mounted () {
    this.loadData()
  },
  methods: {
    ...mapMutations('orderTerminateCard', {
      setPageSize: SET_PAGE_SIZE,
      setOrderBy: SET_ORDER_BY,
      setOrderDirection: SET_ORDER_DIRECTION,
      setSelectedItems: SET_SELECTED_ITEMS,
      addSelectedItem: ADD_SELECTED_ITEM,
      deleteSelectedItem: DELETE_SELECTED_ITEM
    }),
    ...mapActions('orderTerminateCard', [
      'loadTerminableCards'
    ]),
    loadData: async function () {
      try {
        await this.loadTerminableCards()
      } catch (error) {
        this.showAlertForErrorAndRedirectToRoute(error, {}, {401: {name: 'login'}})
      }
    },
    setPageSizeAndLoadData (value) {
      this.setPageSize(parseInt(value))
      this.loadData()
    },
    setOrderingAndLoadData (ordering) {
      this.setOrderBy(ordering.orderBy)
      this.setOrderDirection(ordering.orderDirection)
      this.loadData()
    },
    updateRowCheck (eventData) {
      if (eventData.newIsCheckboxChecked) {
        if (this.isCardChecked(eventData.cardSummary.cardId)) {
          return
        }

        this.addSelectedItem(eventData.cardSummary)
      } else {
        this.deleteSelectedItem(eventData.cardSummary)
      }
    },
    isCardChecked (cardId) {
      return this.selectedItems.findIndex(card => card.cardId === cardId) !== -1
    },
    async submitCardTermination () {
      try {
        await this.$store.dispatch('orderTerminateCard/submitOrderTerminateCards')
        this.setSelectedItems([])
        this.showAlert(this.$t('orderTerminateCard.cardTerminationMessageSuccess'))
        this.$router.push({name: 'order'})
      } catch (error) {
        if (error.validationErrorResult && error.validationErrorResult.validationErrors) {
          error.validationErrorResult.validationErrors.forEach(propertyError => {
            this.showAlert(this.$te(`orderTerminateCard.validation['${propertyError.code}']`)
              ? this.$t(
                `orderTerminateCard.validation['${propertyError.code}']`,
                { fieldName: this.$t(`orderTerminateCard.fieldName['${propertyError.path}']`) }
              ) : propertyError.message
            )
          })
        } else {
          this.showAlertForErrorAndRedirectToRoute(error, {}, {401: {'name': 'login'}})
        }
      }
    }
  }
}
</script>

<style scoped>
  #submitCardTerminationText {
    clear: both;
    margin-top: 100px;
  }

  #submitCardTermination {
    margin-top: 30px;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/OrderTerminateCardPage.vue